import { ref, readonly } from 'vue'

/**
 * Gerenciador de estado de loading para requisições
 * Utiliza sistema de contagem para controlar múltiplas requisições simultâneas
 */

// Refs para controle do estado de loading
const _carregando = ref(false)
// Contador para controlar múltiplas requisições simultâneas
const _contadorRequisicoes = ref(0)

export const gerenciadorLoading = {
    /**
     * Inicia o estado de loading
     * Incrementa o contador de requisições ativas
     */
    iniciar() {
        _contadorRequisicoes.value++
        _carregando.value = true
    },

    /**
     * Finaliza o estado de loading
     * Decrementa o contador e desativa o loading quando não há mais requisições
     */
    finalizar() {
        _contadorRequisicoes.value--
        if (_contadorRequisicoes.value <= 0) {
            _contadorRequisicoes.value = 0
            _carregando.value = false
        }
    },

    /**
     * Retorna o estado atual do loading
     * @returns {boolean} - Estado atual do loading
     */
    obterEstado() {
        return _carregando.value
    },

    /**
     * Reseta o estado do loading e o contador
     * Útil em casos de erro ou necessidade de limpeza manual
     */
    resetar() {
        _contadorRequisicoes.value = 0
        _carregando.value = false
    },

    /**
     * Estado readonly do loading para componentes
     */
    estado: readonly(_carregando)
}
